var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoicon8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_6742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9617 2.95605V5.92416H26.6528V7.85464H31.9617V13.7667H34.0369V7.85464H39.4785V5.92416H34.0369V0H31.9617V2.95605Z",
    fill: "#7099A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6118 10.4851V14.7925H6.57617V17.4952H14.6118V26.2427H17.592V17.4952H25.7482V14.7925H17.592V6.17773H14.6118V10.4851Z",
    fill: "#EB912C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2866 10.4851V14.7925H40.251V17.6279H48.2866V26.2427H51.3874V17.6279H59.423V14.7925H51.3874V6.17773H48.2866V10.4851Z",
    fill: "#59879B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1896 25.1563V29.9825H22.249V33.578H31.1896V43.2304H34.8092V33.578H43.7497V29.9825H34.8092V20.3301H31.1896V25.1563Z",
    fill: "#E8762C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4806 27.5935V30.622H52.0391V33.0713H57.4806V39.1161H60.1953V33.0713H65.6369V30.622H60.1953V24.5771H57.4806V27.5935Z",
    fill: "#5B6591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67112 27.8596V30.7553H0.362305V32.8064H5.67112V38.5979H7.74639V32.8064L13.1879 32.6134V30.7553H7.74639V24.9639H5.67112V27.8596Z",
    fill: "#7099A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6118 41.4929V45.8003H6.57617V48.6357H14.6118V57.2505H17.7126V48.6357H25.7482V45.8003H17.7126V37.1855H14.6118V41.4929Z",
    fill: "#C72035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2866 41.4929V45.8003H40.251V48.503H48.2866V57.2505H51.3874V48.503H59.423V45.8003H51.3874V37.1855H48.2866V41.4929Z",
    fill: "#1F447E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7086 52.4366V55.453H26.2671V57.9023H31.7086V63.9471H34.4234V57.9023H39.8649V55.453H34.4234V49.4082H31.7086V52.4366Z",
    fill: "#5B6591"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_6742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.2749,
    height: 64,
    fill: "white",
    transform: "translate(0.362305)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon8);
export default __webpack_public_path__ + "static/media/logoicon8.39488122884e86f26affd96b7420be1a.svg";
export { ForwardRef as ReactComponent };